enum ActionTypes {
  LOAD_BACK_OFFICE_DEVICE_REQUEST = 'LOAD_BACK_OFFICE_DEVICE_REQUEST',
  LOAD_BACK_OFFICE_DEVICE_SUCCESS = 'LOAD_BACK_OFFICE_DEVICE_SUCCESS',
  LOAD_BACK_OFFICE_DEVICE_FAILURE = 'LOAD_BACK_OFFICE_DEVICE_FAILURE',

  SET_BACK_OFFICE_DEVICE = 'SET_BACK_OFFICE_DEVICE'
}

export default ActionTypes;
